import React, { useState, useEffect } from 'react';

import { mediaNewStatistics, mediaNewSubStatistics } from 'lib/api/media';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

let initialization = false;
let initParam = {};
const NewMediaStatistics = () => {
  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);

  const childColumnSet = {
    STATS_DTTM: () => {
      return null;
    },
    ADVER_CNT: () => {
      return null;
    },
  };

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {
    ADVRTS_AMT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'ADVRTS_AMT').label}
            <br />({getHeadObj(headsMap, 'TRGT_ADVRTS_AMT').label})
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const advrtsAmt = getHeadObj(headsMap, 'ADVRTS_AMT');
        const trgtAdvrtsAmt = getHeadObj(headsMap, 'TRGT_ADVRTS_AMT');
        const mcPoint = getHeadObj(headsMap, 'MC_POINT');
        const mcPointRate = getHeadObj(headsMap, 'MC_POINT_RATE');
        return (
          <>
            {makeRowColumn(
              rowObj['ADVRTS_AMT'],
              advrtsAmt.type,
              advrtsAmt.format
            )}
            <span className={'black'}>
              (
              {makeRowColumn(
                rowObj['TRGT_ADVRTS_AMT'],
                trgtAdvrtsAmt.type,
                trgtAdvrtsAmt.format
              )}
              )
            </span>
            <br />
            <span className={'black'}>
              {makeRowColumn(rowObj['MC_POINT'], mcPoint.type, mcPoint.format)}
            </span>
            <span className={'black'}>
              (
              {makeRowColumn(
                rowObj['MC_POINT_RATE'],
                mcPointRate.type,
                mcPointRate.format
              )}
              )
            </span>
          </>
        );
      },
    },
    TRGT_ADVRTS_AMT: {
      merged: true,
    },
    MC_POINT: {
      merged: true,
    },
    MC_POINT_RATE: {
      merged: true,
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initData={initParam}
          initialization={initialization}
          getParam={getParam}
        />
      </FilterWrap>
      {getInitParam && (
        <TableContainer
          dataReqPromise={mediaNewStatistics}
          dataDetailReqPromise={mediaNewSubStatistics}
          params={{ ...params }}
          sort="desc"
          order="ADVRTS_AMT"
          dense={true}
          hasExcel
          hasTotal
          customized={customized}
          childColumnSet={childColumnSet}
        />
      )}
    </>
  );
};

export default NewMediaStatistics;
